import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { ClaimedRewardsListSkeleton } from '@/shared/components/skeletons'
import { RiGiftLine } from '@/shared/icons/remix'
import type { ISpClaimedReward } from '@brushfire/types'
import { ClaimedRewardCard } from './ClaimedRewardCard'
import {
  claimedRewardsCountSx,
  claimedRewardsGridSx,
  claimedRewardsHeaderSx,
  claimedRewardsTitleSx,
} from '../styles/claimedRewardsStyles'

interface Props {
  rewards: ISpClaimedReward[]
  isLoading: boolean
  openTransactionId?: string
}

function formatItemsAvailable(count: number): string {
  const label = count === 1 ? 'item' : 'items'
  return `${count} ${label} Available`
}

export function ClaimedRewardsList({ rewards, isLoading, openTransactionId }: Readonly<Props>) {
  if (isLoading) {
    return <ClaimedRewardsListSkeleton />
  }

  if (rewards.length === 0) {
    return (
      <Box
        sx={{ textAlign: 'center', py: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}
        data-testid="rewards-claimed-empty"
      >
        <RiGiftLine size={48} color="#94a3b8" aria-hidden />
        <Typography component="h3" sx={{ color: '#64748b', fontSize: '16px', fontWeight: 600, m: 0 }}>
          No rewards claimed yet
        </Typography>
      </Box>
    )
  }

  return (
    <Box data-testid="rewards-claimed-list">
      <Box sx={claimedRewardsHeaderSx}>
        <Typography component="h3" sx={claimedRewardsTitleSx}>
          Claimed Reward
        </Typography>
        <Typography sx={claimedRewardsCountSx} data-testid="rewards-claimed-count">
          {formatItemsAvailable(rewards.length)}
        </Typography>
      </Box>

      <Box sx={claimedRewardsGridSx}>
        {rewards.map((reward) => (
          <ClaimedRewardCard
            key={reward.id}
            reward={reward}
            autoOpen={Boolean(
              openTransactionId && reward.transactionId === openTransactionId,
            )}
          />
        ))}
      </Box>
    </Box>
  )
}
